import React, { useEffect, useRef } from 'react';
import { SageClassnames } from '@kajabi/sage-react';
import highlightJs from 'highlight.js';
import useGeneratorTrackingCallback from '../../hooks/useGeneratorTrackingCallback/useGeneratorTrackingCallback';
import CopyButton from '../CopyButton/CopyButton';
import 'highlight.js/styles/github-dark.css';
import './style.scss';

type Props = {
  code: string;
};

const CodeSnippet = ({ code }: Props) => {
  const codeElementRef = useRef(null);
  const highlightJsActive = useRef(false);
  const trackOutPutCopied = useGeneratorTrackingCallback('useTrackOutputCopied');

  const trackClick = () => {
    trackOutPutCopied({ content: code, code: true });
  };
  useEffect(() => {
    if (!codeElementRef.current) return;
    if (highlightJsActive.current) return;

    highlightJs.highlightElement(codeElementRef.current);
    highlightJsActive.current = true;
  });

  return (
    <div className="copy-magic-code-snippet">
      <div
        className={`copy-magic-code-snippet__title
        ${SageClassnames.GRID_TEMPLATES.TE}`}
      >
        Code snippet
        <CopyButton value={code} buttonColor="secondary" iconOnly={true} trackClick={trackClick} />
      </div>
      <pre>
        <code ref={codeElementRef}>{code}</code>
      </pre>
    </div>
  );
};

export default CodeSnippet;
